import { render, staticRenderFns } from "./GroupOrderByDay.vue?vue&type=template&id=a8fdddfc"
import script from "./GroupOrderByDay.vue?vue&type=script&lang=js"
export * from "./GroupOrderByDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports